<div style="width: 100%; height: 100vh; display: flex; justify-content: center; align-items: center; flex-direction: column;">
  <h1 style="margin-bottom: 20px;">Aviso de Privacidad</h1>
  <iframe [src]="pdfUrl" width="90%" height="80%" style="border: 1px solid #ccc;"></iframe>
  <p style="margin-top: 10px;"><a [href]="pdfDirectUrl" target="_blank">Abrir en nueva pestaña</a></p>
</div>